import { render } from "./EditSupportAgentDialog.vue?vue&type=template&id=cc7e96e6"
import script from "./EditSupportAgentDialog.vue?vue&type=script&lang=js"
export * from "./EditSupportAgentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__